// Import FirebaseAuth and firebase.
import React, { useEffect, useContext } from 'react';
import get from 'lodash/get';
import { useLocation, Redirect } from 'react-router-dom';
import StyledFirebaseAuth from 'react-firebaseui/StyledFirebaseAuth';
import firebase from 'firebase';

import { AppContext } from './AppContext';

// Configure Firebase.
const firebaseConfig = {
  apiKey: "AIzaSyBXf_oX9jCOdNg3H0tEjps0zSFbSvn9kkc",
  authDomain: "acretrader-ds.firebaseapp.com",
  projectId: "acretrader-ds",
  storageBucket: "acretrader-ds.appspot.com",
  messagingSenderId: "133631076873",
  appId: "1:133631076873:web:77e2947dd5fd96d9ee66d8",
  measurementId: "G-8J20V9JW4N"
};
firebase.initializeApp(firebaseConfig);



// Configure FirebaseUI.
const uiConfig = {
  // Popup signin flow rather than redirect flow.
  signInFlow: 'popup',
  // We will display Google and Facebook as auth providers.
  signInOptions: [
    firebase.auth.GoogleAuthProvider.PROVIDER_ID,
  ],
  callbacks: {
    // Avoid redirects after sign-in.
    signInSuccessWithAuthResult: () => false,
  },
};


export function Login() {
  const { user } = useContext(AppContext);
  const location = useLocation();
  const pathname = get(location, 'state.from.pathname', '/');
  
  if (!user) {
    return (
      <div>
        <p></p>
        <StyledFirebaseAuth uiConfig={uiConfig} firebaseAuth={firebase.auth()} />
      </div>
    );
  }

  // {firebase.auth().currentUser.displayName}
  return <Redirect
    to={{
      pathname: pathname,
    }}
  />
}

export const Logout = () => {
  const { setUser } = useContext(AppContext);
  useEffect(() => {
    firebase.auth().signOut();
    setUser(null);
  }, [setUser]);
  return null;
}

